import {inject} from '@angular/core';
import {MissingTranslationHandler, MissingTranslationHandlerParams} from '@ngx-translate/core';
import {PageTypeService} from '../services/page-type/page-type.service';
import {HeaderEnum} from '../enums/routes-header.enum';

export type MissingTranslationHandlerParamsCustom = MissingTranslationHandlerParams & {
  interpolateParams?: Record<string, any>;
};

export class MissingTranslation extends MissingTranslationHandler {
  private lithiumLabelsKeys!: string[];
  private pageTypeService = inject(PageTypeService);
  handle(params: MissingTranslationHandlerParamsCustom) {
    if (params.interpolateParams?.['motor']) {
      const isLithium = this.pageTypeService.getTypePage() === 'energia';
      if (isLithium && !this.lithiumLabelsKeys) {
        this.lithiumLabelsKeys = Object.keys(
          params.translateService.translations.it.customMotor.lithium,
        );
      }

      const customMotorLabels =
        isLithium && this.lithiumLabelsKeys.indexOf(params.interpolateParams?.['motor']) >= 0
          ? params.translateService.translations.it.customMotor.lithium
          : params.translateService.translations.it.customMotor;

      const value = params.translateService.parser.getValue(
        customMotorLabels,
        params.interpolateParams?.['motor'],
      );
      if (value) {
        const interpolated = params.translateService.parser.interpolate(
          value,
          params.interpolateParams,
        );

        return interpolated ?? params.key;
      }
      if (params.translateService.translations.it.CanShowMissingLabel) {
        console.log('missing translation:', params.key, params.interpolateParams);
      }
      return params.key;
    }
    // if (params.translateService.translations.it.CanShowMissingLabel) {
    //   console.log('totally missing:', params);
    // }
    return params.key;
  }
}
